import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state() {
        return {
            user: null,
            keepLoggedIn: false,
            accessToken: null
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user
        },
        setAccessToken(state, token) {
            state.accessToken = token
        },
        clearAccessToken(state) {
            state.accessToken = null
        },
        logOut(state) {
            state.user = null
            state.accessToken = null
            localStorage.removeItem('user')
        },
        setKeepLoggedIn(state, value) {
            state.keepLoggedIn = value
        }

    },
    actions: {
        logout({ commit }) {
            if (window.__refreshTimer) clearTimeout(window.__refreshTimer)
            commit('setUser', null)
            commit('clearAccessToken')
            commit('setKeepLoggedIn', false)

            commit('waarnemersModule/clearWaarnemer', null, { root: true })
            commit('rollenModule/clearRollen', null, { root: true })

            localStorage.clear()
            sessionStorage.clear()
        },
        async login({ commit }, { user, keepLoggedIn }) {
            const response = await axiosInstance.post('/zon/auth/login', user)
            const loggedInUser = {
                id: response.data.id,
                email: response.data.email,
                rolId: response.data.rolId
            }
            const accessToken  = response.data.accessToken
            const refreshToken = response.data.refreshToken
            commit('setUser', loggedInUser)
            commit('setKeepLoggedIn', keepLoggedIn)

            // ACCESS TOKEN → MEMORY (Vuex)
            commit('setAccessToken', accessToken)

            // REFRESH TOKEN → PERSISTENT STORAGE
            const storage = keepLoggedIn ? localStorage : sessionStorage
            storage.setItem('user', JSON.stringify(loggedInUser))
            storage.setItem('refreshToken', refreshToken)
            storage.setItem('keepLoggedIn', JSON.stringify(keepLoggedIn))
        },
        async loginAndInit({ dispatch, rootState }, payload) {
            // 1. Login
            await dispatch('login', payload)
            // 2. Fetch waarnemer
            await dispatch(
                'waarnemersModule/fetchWaarnemerMetEmail',
                payload.user.email,
                { root: true }
            )
            const waarnemer = rootState.waarnemersModule.waarnemer
            if (!waarnemer) {
                throw new Error('Waarnemer not loaded')
            }
            // 3. Fetch role
            await dispatch(
                'rollenModule/fetchRolById',
                waarnemer.rolId,
                { root: true }
            )
        },
        async refreshAccessToken({ commit, state }) {
            const storage = state.keepLoggedIn ? localStorage : sessionStorage
            const refreshToken = storage.getItem('refreshToken')

            if (!refreshToken) return null

            try {
                const res = await axiosInstance.post('/zon/auth/refresh', null, {
                    headers: { Authorization: `Bearer ${refreshToken}` }
                })
                const newAccess  = res.data.accessToken
                const newRefresh = res.data.refreshToken
                commit('setAccessToken', newAccess)
                storage.setItem('refreshToken', newRefresh)
                return newAccess

            } catch (e) {
                return null
            }
        },

        async initAuth({ commit, dispatch, state }) {
            const storedKeep =
                localStorage.getItem('keepLoggedIn') === 'true'
            const storage = storedKeep ? localStorage : sessionStorage
            const storedUser = storage.getItem('user')

            if (!storedUser) {
                return
            }
            commit('setUser', JSON.parse(storedUser))
            commit('setKeepLoggedIn', storedKeep)
            try {
                const token = await dispatch('refreshAccessToken')
            } catch (e) {
                await dispatch('logout')
            }
        }
    },
    getters: {
        isAuthenticated: state =>
            !!state.user && !!state.accessToken,
    },
}